import { useTranslation } from "react-i18next";
import { Languages, Loader2 } from "lucide-react";

import { Button } from "@/components/ui/button";

interface TranslateSectionButtonProps {
  /** Invoked to translate every field in the section. */
  onTranslate: () => void;
  /** The number of fields that will be translated (for the label). */
  count: number;
  busy?: boolean;
  /** Whether any field in the section has a source value to translate. */
  enabled?: boolean;
}

/**
 * The section-level translate-all control at the top inline-start of any
 * multi-field section (README section 0.1.2, "section-level translate-all").
 * Issues a single batched request rather than one call per field.
 */
export function TranslateSectionButton({
  onTranslate,
  count,
  busy = false,
  enabled = true,
}: TranslateSectionButtonProps) {
  const { t } = useTranslation();
  return (
    <Button
      type="button"
      size="sm"
      variant="outline"
      onClick={onTranslate}
      disabled={!enabled || busy || count === 0}
    >
      {busy ? (
        <Loader2 className="h-4 w-4 animate-spin" />
      ) : (
        <Languages className="h-4 w-4" />
      )}
      {t("translations.translateAll", { count })}
    </Button>
  );
}
